import { Controller } from 'stimulus';
import jump from 'jump.js';

/**
 * Jump to target
 *
 * @class Jump
 * @extends {Controller}
 */
class Jump extends Controller {
  onJumpClick() {
    const offset = /^(#|\.)/.test(this.data.get('offset'))
      ? document.querySelector(this.data.get('offset')).offsetHeight * -1
      : parseInt(this.data.get('offset'), 10);

    jump(this.data.get('target'), {
      offset,
      duration: parseInt(this.data.get('duration'), 10) || 1000,
    });
  }
}

Jump.targets = [
  //
];

export default Jump;
